import request from '@/utils/request'; // 复用项目统一的 axios 实例

// 成果管理模块所有接口，统一导出（与仪器管理接口风格保持一致）
export default {
    // 1. 查询成果列表（分页+搜索）
    // params：支持 pageNum、pageSize、nameKeyword 等参数
    getList(params) {
        return request({
            url: '/experts/',
            method: 'get',
            params // GET 请求参数拼在 URL 后（如 ?pageNum=1&pageSize=10&nameKeyword=xxx）
        });
    },

    // 2. 新增成果数据（POST 请求，JSON 格式）
    create(expertData,param) {
        return request({
            url: '/experts/',
            method: 'post',
            data: expertData, // 表单数据（含 projectName、category 等字段）
            params:param
        });
    },

    // 3. 编辑成果数据（PUT 请求，JSON 格式）
    update(expertData,param) {
        // 校验主键 ID（成果实体主键为 id，仪器是 instrumentNo，此处需区分）
        if (!expertData.id) {
            console.error("编辑失败：成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url: '/experts/',
            method: 'put',
            data: expertData, // 表单数据（含 id 主键 + 其他修改字段）,
            params:param
        });
    },

    // 4. 删除成果数据（DELETE 请求，路径传参）
    delete(id) {
        // 校验主键 ID（成果用 id，仪器用 instrumentNo）
        if (!id) {
            console.error("删除失败：成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url: `/experts/${id}`, // 路径拼接 ID（与仪器管理的 instrumentNo 对应）
            method: 'delete'
        });
    },
    //5. 获取单个专家
    getColumnById(id){
        if (!id) {
            console.error("成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url:`/experts/${id}`,
            method:'get'
        })

    },
    //6. 根据机构id获取专家
    getExpertsByInstitutionId(id){
        if (!id) {
            console.error("机构 ID 不能为空");
            return Promise.reject(new Error("机构 ID 不能为空"));
        }
        return request({
            url:`/experts/institutionId`,
            method:'get',
            params:{institutionId:id}
        })
    }
};